/**
 * @file Cluster.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Service from './Service'
import Request from '../components/http/request'

const defaultJsonHeaders = {
  headers: {
    'Accept': 'application/json',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json'
  }
}

/**
 * Billing Management Service
 * @class
 */
class Cluster extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
  }

  /**
   * Get data to cluster
   *
   * @async
   * @function getData
   * @param {Object} options - Input params
   * @param {Object} headers - Http header collection
   * @return {Promise<json>} The json with the result
   */
  async getData (options = {}, headers = {}) {
    return new Promise((resolve, reject) => {
      if (typeof options === 'undefined') reject(new Error('Esperada as opções do cluster'))
      let requestHeaders = defaultJsonHeaders
      if (Object.keys(headers).length > 0) {
        defaultJsonHeaders.headers = Object.assign({}, headers, defaultJsonHeaders.headers)
      }
      const request = new Request({tag: 'cluster'})
      // const request = new Request({environment: 'local', tag: 'cluster'})
      let endPoint = `/clustered`
      request.post(endPoint, options, requestHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get data to kmeans cluster
   *
   * @async
   * @function getKMeans
   * @param {Object} options - Input params
   * @param {Object} headers - Http header collection
   * @return {Promise<json>} The json with the result
   */
  async getKMeans (options = {}, headers = {}) {
    return new Promise((resolve, reject) => {
      if (typeof options === 'undefined') reject(new Error('Esperada as opções do cluster'))
      let requestHeaders = defaultJsonHeaders
      if (Object.keys(headers).length > 0) {
        defaultJsonHeaders.headers = Object.assign({}, headers, defaultJsonHeaders.headers)
      }
      const request = new Request({tag: 'cluster'})
      // const request = new Request({environment: 'local', tag: 'cluster'})
      let endPoint = `/cluster/kmeans`
      request.post(endPoint, options, requestHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }
}

export { Cluster }
